import { motion } from 'framer-motion';

export default function LoadingScreen({ onDone }) {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
      className="fixed inset-0 z-[100] bg-paper flex flex-col justify-between p-6 md:p-10"
      data-testid="loading-screen"
    >
      <div className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.3em] text-ink-dim">
        <span className="dot" />
        <span>Rotama · Vol. 01</span>
      </div>
      <div className="flex items-end justify-between">
        <div className="font-serif italic text-[16vw] md:text-[10vw] leading-[0.9] tracking-[-0.03em]">
          <motion.span
            initial={{ y: '110%' }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
            className="block"
          >
            forging…
          </motion.span>
        </div>
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: '100%' }}
          transition={{ duration: 1.6, ease: 'easeInOut' }}
          onAnimationComplete={onDone}
          className="hidden md:block h-px bg-ember max-w-[40%] ml-8 self-end mb-6"
        />
      </div>
      <div className="flex items-center justify-between font-mono text-[10px] uppercase tracking-[0.3em] text-ink-dim">
        <span>© MMXXV</span>
        <span className="text-ember">Athens ⇢ Everywhere</span>
      </div>
    </motion.div>
  );
}
